import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import PartialReportRow from './PartialReportRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ bureauReportList }) =>
  bureauReportList.map(report => (
    <PartialReportRow key={report.id} {...report} />
  ));

const PartialReportTable = ({
  bureauReportList,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell
          variant="head"
          key="date"
          sx={{ width: '33%' }}
          align="center"
        >
          {t('BUREAU_REPORTS.DATE')}
        </TableCell>

        <TableCell
          variant="head"
          key="upToDateContracts"
          align="center"
          sx={{ width: '34%' }}
        >
          {t('BUREAU_REPORTS.CONTRACTS_UPDATED')}
        </TableCell>

        <TableCell
          variant="head"
          key="actions"
          align="right"
          sx={{ width: '33%' }}
        />
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => <Tbody bureauReportList={bureauReportList} />,
    [bureauReportList]
  );

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, bureauReportList, count, handleChangePage, t]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

PartialReportTable.propTypes = {
  bureauReportList: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};
export default PartialReportTable;
